var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"model",attrs:{"id":"model"}},[_c(_vm.scene,{tag:"component",attrs:{"currentImage":_vm.currentImage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }